import { configureStore } from "@reduxjs/toolkit";
import { api } from "../Api/api";
import cartReducer from '../cartSlice';
import { rtkQueryErrorLogger } from "../error";
import cartCount from "../reducer/CartCountSlice";
import wishlistCount from '../reducer/WhislistCountSlice';
import authReducer from '../reducer/authslice';

const store = configureStore({
    reducer: {
        [api.reducerPath]: api.reducer,
        cart: cartReducer,
        auth: authReducer,

        cartcount: cartCount,
        wishlistCount: wishlistCount,
    },
    middleware: getDefaultMiddleware => {
        return getDefaultMiddleware().concat(api.middleware, rtkQueryErrorLogger)
    }
})
export default store